import fetch from 'cross-fetch';
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

export const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/cldmgu1sz16v001tcf3b51sca/master",
    fetch
  }),
  cache: new InMemoryCache(),
});